module.exports = __webpack_public_path__ + "img/bhi.5f7b252b.png";